export default __webpack_public_path__ + "static/media/47-whale-stuff.a6fe1703.jpg";